import { combineReducers } from "redux";
import api from "./api";
import ui from "./ui";
import client from "./client";

export default combineReducers({
    api,
    ui,
    client
    // data reducers go here
});
